import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowRight = () => {
  return (
    <g>
      <path d="m15.9177 7.7134a.75.75 0 0 0 -.1618-.2436l-6.04-6.04a.75.75 0 1 0 -1.0601 1.0602l4.7593 4.76h-12.6397a.75.75 0 1 0 0 1.5h12.64l-4.7596 4.76a.75.75 0 1 0 1.0605 1.06l6.04-6.04a.7527.7527 0 0 0 .1618-.8169z" />
    </g>
  );
};

export default withIcon(IconArrowRight);
